@if (!editEnabled) {
  <odx-card class="container" (interact)="onClick()" variant="launch-tile-centered">
    @if ((isReadOnlyUser$ | async) === false) {
      <odx-menu size="medium">
        @if (fileType) {
          <button odxButton odxMenuItem (click)="$event.stopPropagation(); onDownload()">
            <odx-icon name="download" size="medium" alignleft></odx-icon>
            <span i18n="@@global.download">Download</span>
          </button>
        }
        @if (!fileType) {
          <button
            odxButton
            odxMenuItem
            [disabled]="(hasWritePermission$ | async) === false"
            (click)="$event.stopPropagation(); onEdit()"
          >
            <odx-icon name="edit" size="medium" alignleft></odx-icon>
            <span i18n="@@global.edit">Bearbeiten</span>
          </button>
        }
        <button
          odxButton
          odxMenuItem
          [disabled]="(hasWritePermission$ | async) === false"
          (click)="$event.stopPropagation(); onDelete()"
        >
          <odx-icon name="delete" size="medium" alignleft></odx-icon>
          <span i18n="@@global.delete">Löschen</span>
        </button>
      </odx-menu>
    }
    <div odxLayout="flex" class="content flex-column">
      <h6 class="odx-title-6 card-title">{{ fileName }}</h6>
      @if ((businessScope$ | async) === BusinessScope.MONITORING && tags?.length) {
        <div class="tag-container">
          @for (tag of tags; track tag) {
            <odx-chip removable="false" size="small" variant="secondary">
              {{ tag | translateFloorplanTag }}
            </odx-chip>
          }
        </div>
      }
      <!-- prettier-ignore-attribute style -->
      <div class="file-wrapper" [ngStyle]="{ 'background-image': fileUrl ? 'url(' + fileUrl + ')' : 'none' }">
        @if (!fileUrl && !fileType) {
          <div class="file-placeholder h-100" i18n="@@projectDetails.emptyFloorplanName">Leerer Grundrissplan</div>
        }
        @if (fileType) {
          <div class="icon-container"><odx-icon size="xlarge" [name]="setIcon()"></odx-icon></div>
        }
      </div>
      @if (description) {
        <div class="description">
          <span class="odx-title-6" i18n="@@projectDetails.floorplan.description.label">Beschreibung</span>
          <p>{{ description }}</p>
        </div>
      }
    </div>
  </odx-card>
} @else {
  <odx-content-box class="file-content-box">
    <form odxForm [formGroup]="editForm" class="form-content">
      <odx-form-field i18n-label="@@projectDetails.emptyFloorplanNameForm.label" label="Name" odxLayout="6">
        <input
          formControlName="name"
          odxFormFieldControl
          placeholder="Name"
          i18n-placeholder="@@projectDetails.emptyFloorplanNameForm.placeholder"
          data-testid="input.floorplanName"
        />
      </odx-form-field>
      @if ((businessScope$ | async) === BusinessScope.MONITORING) {
        <odx-form-field i18n-label="@@projectDetails.floorplan.form.tags.label" label="Tags">
          <odx-select multiple formControlName="tags" odxFormFieldControl>
            @for (item of tagList$ | async | odxAutocompleteSearchFilter; track item) {
              <odx-select-option [value]="item">{{ item | translateFloorplanTag }}</odx-select-option>
            }
            <input
              placeholder="Nach Tag suchen..."
              i18n-placeholder="@@projectDetails.floorplan.form.tags.placeholder"
              odxSelectSearchField="Kein Tag gefunden"
              i18n-odxSelectSearchField="@@projectDetails.floorplan.form.tags.noResult"
            />
          </odx-select>
        </odx-form-field>
      }

      <!-- prettier-ignore-attribute style -->
      <div class="file-wrapper" [ngStyle]="{ 'background-image': 'url(' + fileUrl + ')' }">
        @if (!fileUrl) {
          <div class="file-placeholder h-100" i18n="@@projectDetails.emptyFloorplanName">Leerer Grundrissplan</div>
        }
        @if (fileType) {
          <div class="icon-container"><odx-icon size="xlarge" [name]="setIcon()"></odx-icon></div>
        }
      </div>

      <odx-form-field i18n-label="@@projectDetails.floorplan.form.description.label" label="Beschreibung">
        <textarea formControlName="description" odxFormFieldControl></textarea>
      </odx-form-field>

      <div class="button-container">
        <button odxButton variant="secondary" (click)="cancelEditMode()" data-testid="floorplan-cancel" i18n="@@global.dismiss">
          Abbrechen
        </button>

        @if ((isReadOnlyUser$ | async) === false) {
          <button odxButton variant="secondary" (click)="onDelete()" data-testid="floorplan-delete" i18n="@@global.delete">
            Löschen
          </button>
        }
        <button
          odxButton
          variant="primary"
          type="submit"
          class="save-button"
          (click)="$event.stopPropagation(); onSubmit()"
          data-testid="floorplan-save"
          i18n="@@global.save"
        >
          Speichern
        </button>
      </div>
    </form>
  </odx-content-box>
}
